import { render, staticRenderFns } from "./DashboardRegistredApplications.vue?vue&type=template&id=2321f998&"
import script from "./DashboardRegistredApplications.vue?vue&type=script&lang=js&"
export * from "./DashboardRegistredApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports